import { motion } from "framer-motion";
import { CAPABILITIES } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";

export function Capabilities() {
  return (
    <section id="capabilities" className="relative px-5 py-24 sm:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          index="01"
          kicker="Capabilities"
          title="One engineer, the whole stack — silicon to cloud."
          blurb="Forward deployed means I don't hand off at the interface. I take a problem from the board, through the firmware and the network, up into the software and the agents on top — and I stay until it works in the field."
        />

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.08 } } }}
          className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
        >
          {CAPABILITIES.map((c) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.title}
                variants={{
                  hidden: { opacity: 0, y: 16 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
                }}
                className="brackets group relative panel rounded-[var(--radius-lg)] p-6 transition-colors hover:bg-ink-900/70"
              >
                <div className="flex items-center justify-between">
                  <div className="inline-flex size-11 items-center justify-center rounded-[var(--radius-md)] border border-signal-500/25 bg-signal-500/10 text-signal-400 transition-colors group-hover:bg-signal-500/15">
                    <Icon className="size-5" />
                  </div>
                  <span className="font-mono text-[0.6rem] uppercase tracking-[0.16em] text-ink-600">
                    {c.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-ink-50">{c.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-ink-400">{c.body}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
